import { IJkitTourProgressRecord } from './tour.model';

export function readJkitTourProgress(storageKey: string): IJkitTourProgressRecord[] {
	if (typeof window === 'undefined') return [];

	try {
		const raw = window.localStorage.getItem(storageKey);
		if (!raw) return [];

		const parsed = JSON.parse(raw);
		if (!Array.isArray(parsed)) return [];

		return parsed
			.filter((item): item is IJkitTourProgressRecord => item && typeof item === 'object' && typeof item.TourId === 'string')
			.map(item => ({
				TourId: item.TourId,
				UserId: typeof item.UserId === 'string' ? item.UserId : undefined,
				App: typeof item.App === 'string' ? item.App : undefined,
				State: typeof item.State === 'string' ? item.State : undefined,
				LastUpdated: typeof item.LastUpdated === 'string' ? item.LastUpdated : undefined
			}));
	} catch {
		return [];
	}
}

export function writeJkitTourProgress(storageKey: string, records: readonly IJkitTourProgressRecord[]): void {
	if (typeof window === 'undefined') return;
	const sanitized = records.map(record => ({
		TourId: record.TourId,
		UserId: record.UserId,
		App: record.App,
		State: record.State,
		LastUpdated: record.LastUpdated
	}));
	window.localStorage.setItem(storageKey, JSON.stringify(sanitized));
}

export function upsertJkitTourProgress(
	records: readonly IJkitTourProgressRecord[],
	id: string,
	patch: Partial<IJkitTourProgressRecord>,
	meta?: Partial<IJkitTourProgressRecord> | null
): IJkitTourProgressRecord[] {
	const index = records.findIndex(entry => entry.TourId === id);
	const base: IJkitTourProgressRecord = index >= 0 ? records[index] : { TourId: id, ...(meta ?? {}) };
	const next: IJkitTourProgressRecord = {
		...base,
		...patch,
		TourId: id
	};

	if (index >= 0) {
		const cloned = [...records];
		cloned[index] = next;
		return cloned;
	}

	return [...records, next];
}
